import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";

import { useGetQuotationFormConfig } from "api/queries/quotation-form/useGetQuotationFormConfig";
import { useGetQuoteRequestDetails } from "api/queries/quotes/useGetQuoteRequestDetails";
import { FormattedMessage } from "react-intl";

export default function RequestSummary() {
  const id = useParams().id?.toUpperCase();

  const { data: quotationConfigData } = useGetQuotationFormConfig(id!, {
    enabled: !!id,
    refetchOnMount: false,
  });

  const { data: quoteRequestDetails } = useGetQuoteRequestDetails({
    shipmentId: id!,
    options: {
      enabled: !!id,
      refetchOnMount: false,
    },
  });

  return (
    <>
      <div className="mb-4 font-weight-bold">
        <FormattedMessage id="quotation-form.requestSummary" defaultMessage="Request summary" />
      </div>

      <div className="font-b3 space-y-2">
        <Row>
          <Col className="text-secondary">
            <FormattedMessage id="quotation-form.shipper" defaultMessage="Shipper" />
          </Col>
          <Col>{quoteRequestDetails?.organization?.shipper}</Col>
        </Row>

        <Row>
          <Col className="text-secondary">
            <FormattedMessage id="quotation-form.paymentLocation" defaultMessage="Payment Location" />
          </Col>
          <Col>{quoteRequestDetails?.organization?.payment_location}</Col>
        </Row>

        <Row>
          <Col className="text-secondary">
            <FormattedMessage id="quotation-form.pickupLocation" defaultMessage="Pick-up location" />
          </Col>
          <Col>
            {[
              quoteRequestDetails?.schedule?.pickup_city,
              quoteRequestDetails?.schedule?.pickup_state_code,
              quoteRequestDetails?.schedule?.pickup_country,
            ]
              .filter(Boolean)
              .join(", ")}
          </Col>
        </Row>

        <Row>
          <Col className="text-secondary">
            <FormattedMessage id="quotation-form.deliveryLocation" defaultMessage="Delivery location" />
          </Col>
          <Col>
            {[
              quoteRequestDetails?.schedule?.stop1_city,
              quoteRequestDetails?.schedule?.stop1_state_code,
              quoteRequestDetails?.schedule?.stop1_country,
            ]
              .filter(Boolean)
              .join(", ")}
          </Col>
        </Row>

        <Row>
          <Col className="text-secondary">
            <FormattedMessage id="quotation-form.team" defaultMessage="Team" />
          </Col>
          <Col>{quotationConfigData?.assigned_team?.team_name}</Col>
        </Row>
      </div>
    </>
  );
}
